import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';

type ProjectKey = string;

export const getBaseAutomationUrl = ({
	projectKey,
	projectType,
	isSimplified,
}: {
	isSimplified: boolean;
	projectType: ProjectType;
	projectKey: ProjectKey;
}): string => {
	/**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */
	if (projectType === 'service_desk') {
		return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
	}
	if (projectType === 'business') {
		return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
	}
	return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${
		isSimplified ? 'automation' : 'automate'
	}`;
};
